<script setup>
/**
 * The shell every inline-editable table cell opens: the shared Popover, which
 * teleports to the body. Positioning it inside the row is not an option - the
 * table scrolls horizontally, so an in-flow menu is clipped by that container.
 */
import Popover from 'dashboard/components-next/popover/Popover.vue';

defineProps({
  align: {
    type: String,
    default: 'start',
    validator: value => ['start', 'end'].includes(value),
  },
  width: { type: String, default: 'w-56' },
});

const emit = defineEmits(['show']);
</script>

<template>
  <Popover :align="align" disable-mobile-view @show="emit('show')">
    <template #default="{ isOpen }">
      <slot name="trigger" :is-open="isOpen" />
    </template>
    <template #content="{ hide }">
      <div role="menu" class="flex flex-col p-1" :class="width">
        <slot :hide="hide" />
      </div>
    </template>
  </Popover>
</template>
